import Vue, { VueConstructor } from 'vue';
import { ApplicationInsights, IApplicationInsights } from '@microsoft/applicationinsights-web';

declare module 'vue/types/vue' {
    interface Vue {
        $appInsights: IApplicationInsights;
    }
}

export interface IAppInsightsOptions {
    instrumentationKey: string;
    router?: any;
    baseName?: string;
}

export function AppInsightsPlugin(VueC: VueConstructor, options?: IAppInsightsOptions): void {

    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: options ? options.instrumentationKey : 'dummy',
        },
    }).loadAppInsights();

    VueC.prototype.$appInsights = appInsights;

    // Watch route event if router option is defined.
    if (options && options.router) {
        const router = options.router;
        const baseName = options.baseName || '(Vue App)';

        router.beforeEach( (route: any, from: any, next: any) => {
            const name = baseName + ' / ' + route.name;
            appInsights.startTrackPage(name);
            next();
        });

        router.afterEach( (route: any) => {
            const name = baseName + ' / ' + route.name;
            const url = location.protocol + '//' + location.host + route.fullPath;
            appInsights.stopTrackPage(name, url);
        });
    }
}

